import { Messages } from '../../../constants';

const validationRateio = {
  vehicle: {
    presence: {
      message: Messages.RequiredVehicleValidationMessage,
      allowEmpty: false
    }
  },
  amount: {
    presence: {
      message: Messages.RequiredAmountValidationMessage,
      allowEmpty: false
    },
    numericality: {
      greaterThan: 0,
      message: Messages.RequiredAmountValidationMessage
    }
  },
  percent: {
    presence: {
      message: Messages.RequiredPercentValidationMessage,
      allowEmpty: false
    },
    numericality: {
      greaterThan: 0,
      message: Messages.RequiredPercentValidationMessage
    }
  }
};

export default validationRateio;
